import { twMerge as e } from "tailwind-merge";
import { clsx as t } from "clsx";
//#region src/utils/utils.ts
function n(...n) {
	return e(t(n));
}
var r = class {
	cache = /* @__PURE__ */ new Map();
	maxSize;
	constructor(e = 100) {
		this.maxSize = e;
	}
	get(e) {
		let t = this.cache.get(e);
		return t !== void 0 && (this.cache.delete(e), this.cache.set(e, t)), t;
	}
	set(e, t) {
		if (this.cache.has(e)) this.cache.delete(e);
		else if (this.cache.size >= this.maxSize) {
			let e = this.cache.keys().next().value;
			e !== void 0 && this.cache.delete(e);
		}
		this.cache.set(e, t);
	}
	has(e) {
		return this.cache.has(e);
	}
	get size() {
		return this.cache.size;
	}
};
function i(e, t) {
	return t.some((t) => t.startsWith(".") ? e.name.toLowerCase().endsWith(t.toLowerCase()) : e.type.startsWith(t));
}
//#endregion
export { r as LRUCache, n as cn, i as fileMatchesAccept };
